import { SeoRenderer } from "../../../../common/helpers/seo";

import loadableComponent from "./loadable";

export default {
    component: loadableComponent,
    renderSeo: (_store, allMessage: any, lang: string) => {
        SeoRenderer({
            title: `Musicators - ${allMessage["choir.slogen"]}`,
            description: allMessage["choir.seo.description"],
            app: "choir",
            allMessage,
            lang,
        });
    },
};
